import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { EmptySearchStateStyle } from "./EmptySearchState.style";

export const EmptySearchState: React.FC = () => {
  return (
    <EmptySearchStateStyle>
      <div className="empty-search-container">
        <div className="search-icon-large">
          <SearchOutlined />
        </div>
        <h2 className="empty-search-title">Search for songs, artists, or podcasts</h2>
        <p className="empty-search-subtitle">
          Find your favorite tracks and add them to your playlists
        </p>
        <div className="centered-search-box">
          
        </div>
      </div>
    </EmptySearchStateStyle>
  );
};

